import { render, staticRenderFns } from "./AddObjectiveEvidence.vue?vue&type=template&id=2f8d1f92&scoped=true&"
import script from "./AddObjectiveEvidence.vue?vue&type=script&lang=js&"
export * from "./AddObjectiveEvidence.vue?vue&type=script&lang=js&"
import style0 from "./AddObjectiveEvidence.vue?vue&type=style&index=0&id=2f8d1f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d1f92",
  null
  
)

export default component.exports